import { render, staticRenderFns } from "./colour.vue?vue&type=template&id=51bda625&scoped=true&"
import script from "./colour.vue?vue&type=script&lang=js&"
export * from "./colour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bda625",
  null
  
)

export default component.exports